import * as THREE from 'three'

import { MeshSurfaceSampler } from 'three/examples/jsm/math/MeshSurfaceSampler.js'

export function fillPositionTexture(texture) {
  let arr = texture.image.data

  for (let i = 0; i < arr.length; i+=4) {
    let x = (Math.random() - 0.5) * 0.5
    let y = Math.random() - 0.5
    let z = Math.random() - 0.5

    arr[i + 0] = x
    arr[i + 1] = y
    arr[i + 2] = z
    arr[i + 3] = 1
  }
}  

export function fillSpherePositionTexture(texture) {
  let arr = texture.image.data
  let p = new THREE.Vector3()

  for (let i = 0; i < arr.length; i+=4) {
    getPoint(p, 1.25)

    arr[i + 0] = p.x
    arr[i + 1] = p.y
    arr[i + 2] = p.z
    arr[i + 3] = 1
  }
}  

export function fillPositions(count, mesh) {
  let arr = new Float32Array(count * 4)
  
  let sampler = new MeshSurfaceSampler(mesh).build()
  let pos = new THREE.Vector3()

  for (let i = 0; i < arr.length; i+=3) {
    sampler.sample(pos)

    arr[i + 0] = pos.x
    arr[i + 1] = pos.y
    arr[i + 2] = pos.z
  }

  return arr
}

export function fillSphere(count, size) {
  var len = count * 3
  var data = new Float32Array(len)
  var p = new THREE.Vector3()

  for (var i = 0; i < len; i += 3) {
    getPoint(p, size)
    data[i] = p.x
    data[i + 1] = p.y
    data[i + 2] = p.z
  }
  
  return data
}

// Returns a Float32Array buffer of spherical 3D points
function getPoint(v, size) {
  v.x = Math.random() * 2 - 1
  v.y = Math.random() * 2 - 1
  v.z = Math.random() * 2 - 1

  if (v.length() > 1) return getPoint(v, size)

  return v.normalize().multiplyScalar(size)
}

// Fill terrain plane texture
export function fillTerrainTexture(texture) {
  let arr = texture.image.data
  let radius = 4

  for (let i = 0; i < arr.length; i+=4) {
    let x = (Math.random() - 0.5) * 8.0
    let y = (Math.random() - 0.5) * 4.0
    let z = (Math.random() - 0.5) * radius

    arr[i + 0] = x
    arr[i + 1] = y
    arr[i + 2] = 0
    arr[i + 3] = i / arr.length 
  }
}  